import axios from "axios";

export default {
  getStates() {
    return axios.get("/state-list");
  },

  getGrowersDataOfStateByStateId(selectedStateId) {
    return axios.get(`/state/${selectedStateId}`);
  }
};
